import React from "react";
import styled from "@emotion/styled";
import { Colors } from '../styles/'
import PropTypes from "prop-types";

/*
 ** Loading => gentle fade in/out animated shape for loading
 */

const Loading = ({language}) => {
	const renderAriaLabel = (language) => {
		if (language !== 'en') {
			return 'chargement-en-cours';
		} else {
			return 'loading';
		}
	}
	
	// add colors to helper stylesheet as needed. Default is white
	return (
		<LoadContainer
			aria-label={renderAriaLabel(language)}
		>
			<div className="lds-dual-ring"></div>
		</LoadContainer>
	);
};

Loading.propTypes = {
	language: PropTypes.string,
};

export default Loading;

const LoadContainer = styled.div`
	color: ${Colors.pineGreen};
`;